import React, {useEffect, useState} from "react";
import "./profile.scss";
import "moment/locale/es";
import {FaClipboardUser} from "react-icons/fa6";
import {BsFileImageFill} from "react-icons/bs";
import {FaFlag, FaLaugh} from "react-icons/fa";
import {FormUserInformation} from "./formUserInformation";
import {ProfileStepsContent} from "./profileStepsContent";
import {FormUserAvatar} from "./formUserAvatar";
import {FormUserFlag} from "./formUserFlag";
import {message} from "antd";
import moment from "moment";
import {ValidateIsAdult} from "../../utils/ProfileFunctions";

export const ProfileSteps = ({genderIdentityCatalog,handleUpdateProfile,profileInfo}) => {
    const [percent, setPercent] = useState(0);
    const [colorBar, setColorBar] = useState("gray");
    const [currentStep, setCurrentStep] = useState(1);
    const [statusStep, setStatusStep] = useState("default");

    const handleUpdatePercent = (step) => {
        if(step === 2) setPercent(40);
        if(step === 3) setPercent(70);
        if(step === 4) setPercent(100);
    }

    const handleNextStatus = (status,step) => {
        setStatusStep(status);
        setCurrentStep(step);
        handleUpdatePercent(step);
    }

    const profileLinks = [
        {
            icon: <FaClipboardUser />,
            title: "Información personal",
            subtitle: "Ingresa tus datos personales",
            step: 1,
            status: "form",
        },
        {
            icon: <BsFileImageFill />,
            title: "Sube tu foto",
            subtitle: "Sube tu foto de perfil",
            step: 2,
            status: "form",
        },
        {
            icon: <FaFlag />,
            title: "Selecciona tu bandera",
            subtitle: "Dinos con qué bandera te identificas",
            step: 3,
            status: "form",
        },
    ];

    const handleValidFirstStep = () => {
        if (!profileInfo) return false;

        const hasFirstName = profileInfo.firstName !== " ";
        const hasLastOrMiddleName =
            profileInfo.lastName !== " " || profileInfo.middleName !== " ";
        const hasPronoun =
            profileInfo.pronoun !== null;
        const isAdult = ValidateIsAdult( profileInfo.birthday);

        return (hasFirstName && hasLastOrMiddleName && isAdult && hasPronoun);
    }

    const handleValidSecondStep = () => {
        if (!profileInfo) return false;
        const stepContentComplete = localStorage.getItem("stepContentComplete");
        let hasPhotoProfile = false;

        if(profileInfo.urlProfileImage !== "https://storagervadmindev.blob.core.windows.net/ctnprimecontentmx/BaseImage/Default-avatar.jpg")
            hasPhotoProfile = true;

        return ((JSON.parse(stepContentComplete)?.isComplete === true) || hasPhotoProfile);
    }

    useEffect(() => {
        if(percent === 0)
            setColorBar("gray");
        else if (percent >= 40 && percent < 70)
            setColorBar("#ffc907");
        else if (percent === 70)
            setColorBar("#007FFF");
        else if (percent <= 100 && percent > 70)
            setColorBar("#03C03C");
    }, [percent])

    useEffect(() => {
        const firstStep = handleValidFirstStep();
        if(firstStep)
            handleNextStatus("default",2);

        const secondStep = handleValidSecondStep();
        if(secondStep && firstStep)
            handleNextStatus("default",3);

    }, [profileInfo]);

    return (
        <section className="container-page">
            <article className={"profile__steps"}>
                <h2>Mi perfil</h2>
                {
                    {
                        "default": (
                            <ProfileStepsContent
                                colorBar={colorBar}
                                percent={percent}
                                profileLinks={profileLinks}
                                currentStep={currentStep}
                                handleNextStatus={handleNextStatus}
                                profileInfo={profileInfo}
                            />
                        ),
                        "form": (
                            <>
                                {
                                    {
                                        1: (
                                            <FormUserInformation
                                                handleNextStatus={handleNextStatus}
                                                profileInfo={profileInfo}
                                                handleUpdateProfile={handleUpdateProfile}
                                            />
                                        ),
                                        2: (
                                            <FormUserAvatar
                                                handleNextStatus={handleNextStatus}
                                                profileInfo={profileInfo}
                                                handleUpdateProfile={handleUpdateProfile}
                                            />
                                        ),
                                        3: (
                                            <FormUserFlag
                                                handleNextStatus={handleNextStatus}
                                                profileInfo={profileInfo}
                                                handleUpdateProfile={handleUpdateProfile}
                                                genderIdentityCatalog={genderIdentityCatalog}
                                            />
                                        )
                                    }[currentStep]
                                }
                            </>
                        )
                    }[statusStep]
                }
            </article>
        </section>
    );
}